import styled from "styled-components";

export const ExpandableFooterRoot = styled.div`
    padding: 10px;
`;
